module.exports = __webpack_public_path__ + "assets/5c8bed964c918d4d794009e03b5b207d.mp3";